import { useFormikContext } from "formik";
import React, { useEffect } from "react";
import { SpiffRuleFormValues } from "./spiff-rule-form-values";

export interface DirtyListenerProps {
  setFormDirty: React.Dispatch<React.SetStateAction<boolean>>;
}

export const DirtyListener = ({ setFormDirty }: DirtyListenerProps) => {
  const { dirty } = useFormikContext<SpiffRuleFormValues>();
  useEffect(() => setFormDirty(dirty), [dirty]);
  return null;
};
